import { JSX } from "react";

import { ChangeEvent } from "utils/history/Event";
import {
	BooleanField,
	CalculationField,
	DateField,
	DecimalField,
	Field,
	FieldType,
	GroupField,
	ImageField,
	IntegerField,
	MultiSelectField,
	SelectField,
	TextField,
	UploadField,
	UrlField
} from "../FieldService";
import BooleanInput from "./BooleanInput";
import CalculationInput from "./CalculationInput";
import DateInput from "./DateInput";
import DecimalInput from "./DecimalInput";
import GroupInput from "./GroupInput";
import ImageInput from "./ImageInput";
import IntegerInput from "./IntegerInput";
import MultiSelectInput from "./MultiSelectInput";
import SelectInput from "./SelectInput";
import TextInput from "./TextInput";
import UrlInput from "./UrlInput";

import { InformationRights } from "core/blueprint/trajectory/TrajectoryBlueprintService";
import ExpressionParser from "../parser/ExpressionParser";
import UploadInput from "./UploadInput";

export type FieldInputProps = {
	field: Field;
	editable: boolean;
	rights: InformationRights;
	parser?: ExpressionParser;

	onChange: (event: ChangeEvent, valid: boolean) => void;
};

const FieldInput: React.FC<FieldInputProps> = (props: FieldInputProps) => {
	function getSpecializedField(): JSX.Element {
		switch (props.field.type) {
			case FieldType.BOOLEAN:
				return (
					<BooleanInput
						{...props}
						field={props.field as BooleanField}
					/>
				);
			case FieldType.CALCULATION:
				return (
					<CalculationInput
						{...props}
						field={props.field as CalculationField}
					/>
				);
			case FieldType.DATE:
				return (
					<DateInput {...props} field={props.field as DateField} />
				);
			case FieldType.DECIMAL:
				return (
					<DecimalInput
						{...props}
						field={props.field as DecimalField}
					/>
				);
			case FieldType.GROUP:
				return (
					<GroupInput {...props} field={props.field as GroupField} />
				);
			case FieldType.IMAGE:
				return (
					<ImageInput {...props} field={props.field as ImageField} />
				);
			case FieldType.INTEGER:
				return (
					<IntegerInput
						{...props}
						field={props.field as IntegerField}
					/>
				);
			case FieldType.SELECT:
				return (
					<SelectInput
						{...props}
						field={props.field as SelectField}
					/>
				);
			case FieldType.MULTI_SELECT:
				return (
					<MultiSelectInput
						{...props}
						field={props.field as MultiSelectField}
					/>
				);
			case FieldType.TEXT:
				return (
					<TextInput {...props} field={props.field as TextField} />
				);
			case FieldType.URL:
				return <UrlInput {...props} field={props.field as UrlField} />;
			case FieldType.UPLOAD:
				return (
					<UploadInput
						{...props}
						field={props.field as UploadField}
					/>
				);
			default:
				console.error("Uknown field type '" + props.field.type + "'");
				return <></>;
		}
	}

	return getSpecializedField();
};

export default FieldInput;
